import React, { Component, Fragment } from 'react';
import Wrapper from './../../../../../common/component/Wrapper';
import {
    getTitleTable, formatMoney, columnsTable,
    getDataSource, genaratePaginateFilterSort,
    getPermissionActions
} from '../../../../../../../helpers/functions';
import { parseListRequestParams, getLocaleFullName } from '../../../../../../../utils/commonUtils';
import { generateStringId } from '../../../../../../../utils/orders';
import * as HMS from "../../../../../common/component/Index";
import * as Func from '../../../../../../../helpers/functions';
import SaleReportBySKU, { SaleReportBySkuItem } from '../../../../../../../models/SaleReportBySKU';
import DEFINE, { CHANNELS, DATE_TIME_FORMAT, ORDER, PATHS, SALE_CHANNELS, typeReportSku, VOUCHER } from '../../../../../../../constants/Define';
import { FormWrapperItem, ListComponent, DatePickerComponent } from '../../../../../common/component/Index';
import Button, { ButtonGroup } from '../../../../../common/component/Button';
import * as ANT from 'antd';
import { omit, find, toArray } from 'lodash';
import i18n from "../../../../../../../constants/initLng";
import FontIcon, { SolidIcons } from '../../../../../common/component/FontIcon';
import Span from '../../../../../common/component/Span';
import moment from 'moment';
import EllipsisText from '../../../../../common/component/EllipsisText';
import { Link } from 'react-router-dom';
import AntSelect, { AntOption } from '../../../../../common/component/AntSelect';
// import './ReportList.less';

let permisionActions = [];
const defaultState = {
    filterExport: {}
};

// const ReportListCols = ['id', 'orderCode', 'transactionId', 'paymentType', 'paymentStatus', 'status', 'saleChannel', 'fullname', 'couponCode', 'couponValue', 'subTotal', 'surcharge', 'surchargeDetail', 'totalAmount', 'createdDate', 'note', 'orderItemType', 'groupCode', 'name', 'price', 'salePrice', 'checkCode', 'serialNumber', 'voucherStatus', 'checkedDate', 'operaBookingCode', 'property', 'checkedBy', 'userEmail', 'phoneNumber', 'firstname', 'lastname', 'orderStatus'];
const removeColumns = ['id', 'firstname', 'lastname', 'urlSlug'];
const ReportListCols = ['id', 'orderCode', 'transactionId', 'paymentType', 'paymentStatus', 'orderStatus', 'accountantStatus', 'memberShipCode', 'saleChannel', 'affiliateSource', 'channel', 'orderItemType', 'createdDate', 'fullname', 'email', 'phoneNumber', 'couponCode', 'subTotal', 'surcharge', 'surchargeDetail', 'totalAmount','totalChangeRateCode', 'note', 'skuCode', 'skuName', 'endDate', 'bookingPeriod','urlSlug', 'ticketCode', 'ticketName', 'ticketType', 'checkCode', 'serialNumber', 'voucherStatus', 'salePrice', 'operaBookingCode', 'checkInDate', 'checkOutDate', 'property', 'checkedDate', 'checkedBy', 'firstname', 'lastname'];
const CURRENT_DATE_RANGE_ENUM = {
    DATE: [moment.utc().startOf('days'), moment.utc().endOf('days')],
    WEEK: [moment.utc().startOf('isoWeeks'), moment.utc().endOf('days')],
    MONTH: [moment.utc().startOf('months'), moment.utc().endOf('days')],
}
let orderOnline = ['onepay', 'vnpay', 'onepay_installment']
export default class ReportList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(ReportListCols, [], removeColumns),
            filterByCheckin: false,
            modelItem: ReportListCols,
            componentTable: {
                orderCode: {
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => 
                            <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: record.id })} className={`mr-2 colorPrimary`}>
                                <Span>{text}</Span>
                            </Link>
                },
                transactionId: {
                    render: (transactionId, record) => orderOnline.includes(record.paymentType) ? record.id : transactionId
                },
                fullname: {
                    key: 'fullname',
                    render: (text, data) => data.fullname || getLocaleFullName(data.firstname, data.lastname),
                },
                name: {
                    width: 300,
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
                },
                note: {
                    width: 300,
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                        overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
                },
                couponValue: {
                    align: "right",
                    render: (couponValue) => Func.formatMoney(couponValue)
                },
                price: {
                    align: "right",
                    render: (price) => Func.formatMoney(price)
                },
                salePrice: {
                    align: "right",
                    render: (salePrice) => Func.formatMoney(salePrice)
                },
                subTotal: {
                    align: "right",
                    render: (subTotal) => Func.formatMoney(subTotal)
                },
                surcharge: {
                    align: "right",
                    render: (surcharge) => Func.formatMoney(surcharge)
                },
                totalAmount: {
                    align: "right",
                    render: (amount) => Func.formatMoney(amount)
                },
                totalChangeRateCode: {
                    align: 'right',
                    width: 200,
                    render: (amount) => Func.formatMoney(amount)
                },
                createdDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
                },
                checkedDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
                },
                checkInDate: {
                    render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                checkOutDate: {
                    render: (text, record) => text && record.orderItemType !== 1 && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                skuCode: {
                    key: 'skuCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                ticketType: {
                    render: (text, record) => text && text
                },
                orderStatus: {
                    key: 'orderStatus',
                    render: (status, data) => <Fragment>
                        <HMS.StatusComponent color={data.orderStatus === 2 ? 'green' : (data.orderStatus === 4 ? 'blue' : 'red')}
                            label={i18n.t(`item.order.orderStatus.${data.orderStatus}`)} />
                    </Fragment>,
                    filters: [
                        { value: 1, text: this.props.t(`item.order.orderStatus.1`) },
                        { value: 2, text: this.props.t(`item.order.orderStatus.2`) },
                        // { value: 3, text: this.props.t(`item.order.orderStatus.3`) },
                        // { value: 4, text: this.props.t(`item.order.orderStatus.4`) },
                        { value: 5, text: this.props.t(`item.order.orderStatus.5`) },
                        { value: 6, text: this.props.t(`item.order.orderStatus.6`) },
                        { value: 7, text: this.props.t(`item.order.orderStatus.7`) },
                        { value: 8, text: this.props.t(`item.order.orderStatus.8`) },
                        { value: 9, text: this.props.t(`item.order.orderStatus.9`) },
                    ],
                    filterMultiple: true,
                },
                accountantStatus: {
                    key: 'accountantStatus',
                    render: (status, data) => <Fragment>
                        <HMS.StatusComponent color={data.accountantStatus === 2 ? 'green' : (data.accountantStatus === 4 ? 'blue' : 'red')}
                            label={i18n.t(`item.order.orderStatus.${data.accountantStatus}`)} />
                    </Fragment>,
                    filters: [
                        { value: 1, text: this.props.t(`item.order.orderStatus.1`) },
                        { value: 2, text: this.props.t(`item.order.orderStatus.2`) },
                        // { value: 3, text: this.props.t(`item.order.orderStatus.3`) },
                        // { value: 4, text: this.props.t(`item.order.orderStatus.4`) },
                        { value: 5, text: this.props.t(`item.order.orderStatus.5`) },
                        { value: 6, text: this.props.t(`item.order.orderStatus.6`) },
                        { value: 7, text: this.props.t(`item.order.orderStatus.7`) },
                        { value: 8, text: this.props.t(`item.order.orderStatus.8`) },
                        { value: 9, text: this.props.t(`item.order.orderStatus.9`) },
                    ],
                    filterMultiple: true,
                },  
                paymentStatus: {
                    key: 'paymentStatus',
                    render: (paymentStatus, data) => <Fragment>
                        <HMS.StatusComponent color={paymentStatus === 2 ? 'green' : (paymentStatus === 4 ? 'blue' : 'red')}
                            label={i18n.t(`item.order.paymentStatusEnum.${paymentStatus}`)} />
                        <br />
                    </Fragment>
                },
                paymentType: {
                    key: 'paymentType',
                    render: (paymentType, data) => <Fragment>
                        {paymentType && <div className="g-mt-5">
                            <HMS.StatusComponent color={'gray'}
                                label={i18n.t(`item.order.paymentTypes.${data.paymentType}`)} />
                        </div>
                        }
                    </Fragment>,
                    filters: [
                        { value: 'vnpay', text: this.props.t(`item.order.paymentTypes.vnpay`) },
                        { value: 'onepay', text: this.props.t(`item.order.paymentTypes.onepay`) },
                        // { value: 'zalo', text: this.props.t(`item.order.paymentTypes.zalo`) },
                        // { value: 'shopeepay', text: this.props.t(`item.order.paymentTypes.shopeepay`) },
                        { value: 'paylater', text: this.props.t(`item.order.paymentTypes.paylater`) },
                        { value: 'cash', text: this.props.t(`item.order.paymentTypes.cash`) },
                        { value: 'transfer', text: this.props.t(`item.order.paymentTypes.transfer`) },
                        { value: 'qrcode', text: this.props.t(`item.order.paymentTypes.qrcode`) },
                        { value: 'other', text: this.props.t(`item.order.paymentTypes.other`) },
                        { value: 'momo', text: this.props.t(`item.order.paymentTypes.momo`) },
                        { value: 'twoc2p', text: this.props.t(`item.order.paymentTypes.twoc2p`) },
                    ],
                    filterMultiple: false,
                },
                voucherStatus: {
                    key: 'voucherStatus',
                    render: (status, record) => {
                        const statusEnum = find(toArray(VOUCHER.STATUS), item => item.id === status)
                        return !!statusEnum && <Fragment>
                            <HMS.StatusComponent color={!record.isExpired ? statusEnum.color : 'grey'}
                                label={this.props.t(`item.voucher.statusVoucher.${statusEnum.key}`)} />
                            {record.isLocked && <ANT.Icon type="lock" style={{ color: VOUCHER.STATUS.LOCKED.color }} />}
                        </Fragment>
                    },
                },
                saleChannel: {
                    key: 'saleChannel',
                    render: (value, data) => value && i18n.t(`item.order.saleChannels.${value}`),
                    filters: Object.keys(SALE_CHANNELS).map(item => ({ value: SALE_CHANNELS[item], text: this.props.t(`item.order.saleChannels.${SALE_CHANNELS[item]}`) })),
                    filterMultiple: false,
                },
                channel: {
                    key: 'channels',
                    render: (value, data) => value && i18n.t(`item.order.channels.${value}`),
                    filters: Object.keys(CHANNELS).map(item => (
                        { value: CHANNELS[item], text: this.props.t(`item.order.channels.${CHANNELS[item]}`) 
                    })),
                    filterMultiple: true,
                },
                orderItemType: {
                    key: 'itemTypes',
                    width: 100,
                    render: (type) => {
                        const typeKey = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === type)
                        return typeKey && <ANT.Tooltip key={typeKey} title={this.props.t(`item.order.orderTypes.${ORDER.TYPES[typeKey].key}`)}><Span className="ml-2">
                            <FontIcon key={type} color={ORDER.TYPES[typeKey].color} icon={SolidIcons[ORDER.TYPES[typeKey].icon]} size="lg" />
                        </Span></ANT.Tooltip>
                    },
                    filters: [
                        { value: ORDER.TYPES['VOUCHER'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['VOUCHER'].key}`) },
                        { value: ORDER.TYPES['TOUR'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['TOUR'].key}`) },
                        { value: ORDER.TYPES['VINWONDER'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['VINWONDER'].key}`) },
                        { value: ORDER.TYPES['FLIGHT'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['FLIGHT'].key}`) },
                        { value: ORDER.TYPES['HOTEL'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['HOTEL'].key}`) },
                        { value: ORDER.TYPES['LINKCROSSSELL'].id, text: this.props.t(`item.order.orderTypes.${ORDER.TYPES['LINKCROSSSELL'].key}`) }
                    ],
                    filterMultiple: true,
                },
                skuName: {
                    render: (text, record) => <EllipsisText title={text} content={<a href={record.urlSlug} target="_blank">{text}</a>} contentMaxWidth={300}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
                },
                couponCode: {
                    key: 'couponCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                endDate: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                bookingPeriod: {
                    render: (text, record) => text && moment(moment.utc(text).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
            },
        };
    }

    componentDidMount() {
        permisionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.SALE_REPORT_BY_SKU);
    }

    render() {
        const { t, report, downloading } = this.props;

        return (
            <Wrapper className="col-md-12 p-0 mt-3 report-list">
                <Wrapper className="col-md-12 row m-0 p-0 report-list-title align-items-end">
                    <h3 className={`col-md-2 ml-0 p-0`}>{t('item.report.revenue')}</h3>
                    <Wrapper className={`col-md-5 m-0 p-0 pr-2 button-section`}>
                        {permisionActions && permisionActions.allowExportExcludeUserInfo &&
                        <Button type="primary" onClick={() => this.onExportExcel(true)}
                            icon="download" loading={downloading}
                            disabled={!(report.items && report.items.length)}
                            className="mr-2">{t(`item.report.exportExcelExcludeUser`)}</Button>
                        }
                        {permisionActions && permisionActions.allowExportFileExcel &&
                            <Button type="primary" onClick={() => this.onExportExcel(false)}
                                icon="download" loading={downloading}
                                disabled={!(report.items && report.items.length)}
                                className="mr-2">{t(`item.report.exportExcel`)}</Button>
                        }
                    </Wrapper>
                    <Wrapper className={`align-items-end col-md-4 d-flex flex-column m-0 p-0 pr-2`}>
                        <ButtonGroup>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.DATE })}>{t(`item.report.currentDate`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.WEEK })}>{t(`item.report.currentWeek`)}</Button>
                            <Button type="dashed" onClick={() => this.onSelectDateRange({ fullValue: CURRENT_DATE_RANGE_ENUM.MONTH })}>{t(`item.report.currentMonth`)}</Button>
                        </ButtonGroup>
                        <DatePickerComponent className={`form-control applyDates w100-percent mt-1`}
                            hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                            style={{ padding: 0, border: 0 }}
                            onChange={this.onSelectDateRange} name={`applyDates`}
                            placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                            value={[report.startDate, report.endDate]}
                            en
                        />
                    </Wrapper>
                    <Wrapper className={`align-items-end col-md-1 d-flex flex-column m-0 p-0`}>
                        <AntSelect
                            showArrow
                            // mode="multiple"
                            // suffixIcon={<Icon type="search" />}
                            // filterOption={this.selectFilterSearch}
                            value={this.state.filterByCheckin}
                            name={`filterByCheckin`}
                            onChange={this.onSelectTypeReport}
                            style={{width: '100%'}}
                        >
                            { (typeReportSku || []).map(el => (
                                <AntOption key={ el.text } value={ el.value }>
                                    { el.text }
                                </AntOption>
                            )) }
                        </AntSelect>
                    </Wrapper>
                </Wrapper>
                {this.renderList()}
            </Wrapper>
        );
    }

    renderList() {
        const { report, loading } = this.props;
        const { items } = report
        const filters = omit(report, 'items')
        const { titleItemTable, modelItem, componentTable } = this.state


        return (
            <Wrapper className={`mt-2`}>
                <ListComponent
                    tableKey="sale-report-list"
                    scroll={{ x: 5500 }}
                    classParent="m-0 p-0 sale-report-list"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    rowKey={(record, k) => generateStringId(10)}
                    dataSource={getDataSource(items || [], modelItem)}
                    columns={columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'orderSku'
                    })}
                    pagination={{ total: filters.totalCount, totalPage: filters.totalPage, current: filters.pageIndex, pageSize: filters.pageSize }}
                    onChange={this.onTableChange}
                    componentTableList={{}}
                />
            </Wrapper>
        )
    }

    onSelectDateRange = (data) => {
        const filters = this.getCurrentFilters()
        filters.pageIndex = 1;
        filters.startDate = data.fullValue[0];
        filters.endDate = data.fullValue[1];
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters,filterByCheckin: this.state.filterByCheckin });
    }

    onSelectTypeReport = (value) => {
        const filters = this.getCurrentFilters()
        this.setState({filterByCheckin: value})
        return this.props.onChangeFilters({...this.state.filterExport,...filters,filterByCheckin: value})
    }

    onTableChange = (pagination, filters, sorter) => {
        const currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({ filterExport: newFilters })
        this.props.onChangeFilters({...newFilters,filterByCheckin: this.state.filterByCheckin});
    };

    onChangeFilters = (fieldName, value) => {
        const filters = this.getCurrentFilters()
        filters[fieldName] = value;
        return this.props.onChangeFilters({ ...this.state.filterExport, ...filters })
    }

    onExportExcel = (isExcludeUserInfo = false) => {
        const filters = this.getCurrentFilters();
        filters.pageIndex = undefined;
        filters.pageSize = undefined;
        filters.isExcludeUserInfo = isExcludeUserInfo;
        return this.props.onExportExcel(parseListRequestParams({ ...this.state.filterExport, ...filters }));
    }

    getCurrentFilters() {
        const { report } = this.props;
        return omit(report, ['items', 'totalCount', 'totalPage']);
    }

}

ReportList.defaultProps = {
    report: new SaleReportBySKU(),
    loading: false,
    downloading: false,
    onChangeFilters: filters => { },
    onExportExcel: filters => { },
}

